import projection from '../generated/pwc526f1.json';
import { AcceptanceManifest } from '../types';

export const pwc526f1AcceptanceManifest = projection as AcceptanceManifest;
